import { Box, Typography } from "@mui/material";
import MobileTopBar from "../components/navigation/MobileTopBar";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../components/api";
import Map from "../components/layout/Map";
import LocationIcon from "../components/icons/LocationIcon";
import DropButton from "../components/inputs/DropButton";
import MessageBox from "../components/utils/MessageBox";
import Button from "../components/inputs/Button";
import { Scanner } from "@yudiel/react-qr-scanner";
import { isMobile } from "react-device-detect";

const GymBookingPage = ({ mobile, height, marginTop, user }) => {
  const [loading, setLoading] = useState(false);
  const [gymData, setGymData] = useState(null);
  const { gymId } = useParams(); // Esto extrae gymId de la URL
  const [todaySchedule, setTodaySchedule] = useState([]);
  const [tomorrowSchedule, setTomorrowSchedule] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState({ value: false, type: "booking_confirmation" });
  const [showScannerModal, setShowScannerModal] = useState(false);
  const navigate = useNavigate();

  const handleMakeBooking = () => {
    setLoading(true);
    api.makeBooking(
      selectedSchedule.schedule.value,
      (data) => {
        setLoading(false);
        navigate("/reservar");
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  const handleCancelBooking = () => {
    setLoading(true);
    api.cancelBooking(
      gymData.currentBooking.id,
      (data) => {
        setLoading(false);
        navigate(0);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  const handleScheduleClick = (schedule, day) => {
    setSelectedSchedule({ day, schedule });
    setShowConfirmationModal({ value: true, type: "booking_confirmation" });
  };

  const formatSchedule = () => {
    let todaySchedule = gymData.schedules.todaySchedule.map((schedule) => {
      return {
        text: `${schedule.hour}:${formatTwoDigits(schedule.minutes)}`,
        margin: schedule.accessMarginMinutes,
        value: schedule.id,
      };
    });
    setTodaySchedule(todaySchedule);
    let tomorrowSchedule = gymData.schedules.tomorrowSchedule.map((schedule) => {
      return {
        text: `${schedule.hour}:${formatTwoDigits(schedule.minutes)}`,
        margin: schedule.accessMarginMinutes,
        value: schedule.id,
      };
    });
    setTomorrowSchedule(tomorrowSchedule);
  };

  const formatTwoDigits = (number) => {
    return number < 10 ? `0${number}` : number;
  };

  const getGymData = async () => {
    setLoading(true);
    api.getGym(
      gymId,
      (data) => {
        setGymData(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );

    setLoading(false);
  };

  useEffect(() => {
    if (gymData) {
      formatSchedule();
    }
  }, [gymData]);

  useEffect(() => {
    getGymData();
  }, []);

  const handleQRScan = (qrCode) => {
    api.accessGym(
      qrCode,
      (data) => {
        setShowScannerModal(false);
        setGymData((gym) => ({ ...gym, currentBooking: { ...gym.currentBooking, canCancel: false } }));
      },
      (error) => {
        console.log(error);
        switch (error.data) {
          case "INVALID_CODE":
            alert("QR inválido. Por favor, intenta escanear el QR de nuevo.");
            break;
          case "BOOKING_NOT_FOUND":
            alert("No tienes una reserva activa para este gimnasio.");
            break;
          case "BOOKING_EXPIRED":
            alert("La reserva ha expirado.");
            break;
          case "BOOKING_TOO_EARLY":
            alert("Todavía no puedes acceder al gimnasio con tu reserva.");
            break;
        }
        setShowScannerModal(false);
      }
    );
  };

  return (
    <Box
      sx={{
        height: { height },
        overflow: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        padding: "0px 10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      {mobile > 0 && (
        <MobileTopBar onBack={() => navigate("/reservar")} showBack>
          Reservar
        </MobileTopBar>
      )}
      {showScannerModal && (
        <MessageBox cancelText="Cancelar" onCancel={() => setShowScannerModal(false)}>
          <Box
            style={{ minWidth: "300px", minHeight: "300px", maxWidth: "400px", maxHeight: "400px", padding: "10px" }}
          >
            <Scanner
              onScan={(result) => handleQRScan(result[0].rawValue)}
              components={{ torch: false, tracker: false, zoom: false }}
              onError={(error) => alert(error)}
            />
          </Box>
        </MessageBox>
      )}
      {showConfirmationModal.value && showConfirmationModal.type == "booking_confirmation" && (
        <MessageBox
          acceptText="Confirmar"
          cancelText="Cancelar"
          onAccept={() => {
            handleMakeBooking();
            setShowConfirmationModal({ value: false });
          }}
          onCancel={() => setShowConfirmationModal({ value: false })}
        >
          <Typography
            style={{
              fontWeight: "600",
              fontSize: "36px",
              color: "white",
              textAlign: "center",
              paddingTop: "30px",
            }}
          >
            ¿Confirmar reserva para <span style={{ color: "#FF9700" }}>{gymData.name}</span> a las{" "}
            <span style={{ color: "#FF9700" }}>{selectedSchedule.schedule.text}hs.</span> para{" "}
            <span style={{ color: "#FF9700" }}>{selectedSchedule.day == "today" ? "HOY" : "MAÑANA"}</span>?
          </Typography>
          <Typography
            style={{
              fontWeight: "400",
              fontSize: "20px",
              color: "white",
              textAlign: "center",
              paddingBottom: "30px",
            }}
          >
            Tendrás un margen de tolerancia de +/- {selectedSchedule.schedule.margin} minutos para acceder al gimnasio.
          </Typography>
        </MessageBox>
      )}
      {showConfirmationModal.value && showConfirmationModal.type == "booking_cancellation" && (
        <MessageBox
          acceptText="Confirmar"
          cancelText="Cancelar"
          onAccept={() => {
            handleCancelBooking();
            setShowConfirmationModal({ value: false });
          }}
          onCancel={() => setShowConfirmationModal({ value: false })}
        >
          <Typography
            style={{
              fontWeight: "600",
              fontSize: "36px",
              color: "white",
              textAlign: "center",
              paddingTop: "30px",
            }}
          >
            ¿Cancelar reserva para <span style={{ color: "#FF9700" }}>{gymData.currentBooking.gymName}</span>?
          </Typography>
        </MessageBox>
      )}
      {gymData && (
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "20px",
            maxWidth: "700px",
            gap: "20px",
          }}
        >
          <Box
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              style={{
                backgroundColor: "#1F222A",
                borderRadius: "16px",
                width: "130px",
                height: "130px",
                flexShrink: 0,
              }}
            >
              <img
                src={gymData.iconUrl}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                width: "100%",
                alignItems: "end",
                height: "100%",
                justifyContent: "space-around",
              }}
            >
              <Typography
                style={{
                  fontSize: "36px",
                  fontFamily: "Urbanist",
                  fontWeight: "bold",
                  color: "rgba(255, 255, 255, 1)",
                  lineHeight: "0.9",
                  textAlign: "right",
                }}
              >
                {gymData.name}
              </Typography>
              <Typography
                style={{
                  fontSize: "16px",
                  fontFamily: "Urbanist",
                  fontWeight: "400",
                  color: "rgba(255, 255, 255, 1)",
                  textAlign: "right",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  lineHeight: "1",
                  width: "100%",
                }}
              >
                {gymData.description}
              </Typography>
            </Box>
          </Box>
          {gymData.currentBooking && (
            <>
              <Typography
                style={{
                  fontSize: "20px",
                  fontFamily: "Urbanist",
                  fontWeight: "600",
                  color: "rgba(255, 255, 255, 1)",
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
              >
                {gymData.id == gymData.currentBooking.gymId
                  ? `Tenés una reserva para `
                  : `Ya tenés otra reserva activa en el gimnasio ${gymData.currentBooking.gymName} para `}
                <span style={{ color: "#FF9700" }}>{gymData.currentBooking.day == "TODAY" ? "HOY" : "MAÑANA"}</span> a
                las{" "}
                <span style={{ color: "#FF9700" }}>
                  {gymData.currentBooking.hour}:{formatTwoDigits(gymData.currentBooking.minutes)}
                </span>
                .
              </Typography>
              {gymData.id == gymData.currentBooking.gymId && !gymData.currentBooking.canAccessNow && (
                <Typography
                  style={{
                    fontSize: "16px",
                    fontFamily: "Urbanist",
                    fontWeight: "400",
                    color: "rgba(255, 255, 255, 1)",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%",
                  }}
                >
                  Debes esperar a la hora de tu reserva para poder acceder al gimnasio.
                </Typography>
              )}
              {gymData.id != gymData.currentBooking.gymId ? (
                <Button
                  sx={{ maxWidth: "700px" }}
                  onClick={() => {
                    navigate(`/gimnasio/${gymData.currentBooking.gymId}`, { replace: true });
                    navigate(0);
                  }}
                >
                  Ver reserva
                </Button>
              ) : isMobile ? (
                <Button
                  sx={{ maxWidth: "700px" }}
                  onClick={() => setShowScannerModal(true)}
                  disabled={!gymData.currentBooking.canAccessNow}
                >
                  Escanear QR
                </Button>
              ) : (
                <Typography
                  style={{
                    fontSize: "20px",
                    fontFamily: "Urbanist",
                    fontWeight: "400",
                    color: "rgba(255, 255, 255, 1)",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%",
                  }}
                >
                  Ingresa a Full Pass desde tu celular para escanear el QR y acceder al gimnasio.
                </Typography>
              )}
              {gymData.currentBooking?.canCancel == true && (
                <Button
                  stroked
                  sx={{ maxWidth: "700px" }}
                  onClick={() => setShowConfirmationModal({ value: true, type: "booking_cancellation" })}
                >
                  Cancelar Reserva
                </Button>
              )}
            </>
          )}
          {!gymData.currentBooking &&
            todaySchedule.length == 0 &&
            tomorrowSchedule.length == 0 &&
            gymData.externalBooking && (
              <Button
                sx={{ maxWidth: "700px" }}
                onClick={() => {
                  const msg = `Hola, quiero consultar disponibilidad para el gimnasio ${gymData.name}.
                  ${user.name} ${user.lastName}
                  DNI ${user.dni}.
                  Muchas gracias.`;
                  window.open(
                    `https://api.whatsapp.com/send/?phone=541151330870&text=${msg}&type=phone_number&app_absent=0`
                  );
                }}
              >
                Consultar disponibilidad
              </Button>
            )}
          {todaySchedule.length > 0 && (
            <DropButton
              text={"Reservar para HOY"}
              options={todaySchedule}
              buttonOptions
              onOptionClicked={(option) => handleScheduleClick(option, "today")}
            />
          )}
          {tomorrowSchedule.length > 0 && (
            <DropButton
              text={"Reservar para MAÑANA"}
              options={tomorrowSchedule}
              buttonOptions
              onOptionClicked={(option) => handleScheduleClick(option, "tomorrow")}
              stroked
            />
          )}
          <Box style={{ height: "300px", borderRadius: "20px" }}>
            <Map borderRadius="10px" gyms={[{ ...gymData }]} initialLat={gymData.lat} initialLon={gymData.lon} />
          </Box>
          <Box
            style={{
              display: "flex",
              backgroundColor: "#1F222A",
              borderRadius: "10px",
              padding: "20px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LocationIcon color="white" />
            <Typography
              style={{
                fontSize: "15px",
                fontFamily: "Urbanist",
                fontWeight: "500",
                color: "rgba(255, 255, 255, 1)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                lineHeight: "1",
              }}
            >
              {gymData.address}
            </Typography>
          </Box>

          {mobile > 0 && (
            <div
              style={{
                width: "100%",
                height: "70px",
                color: "rgba(0,0,0,0)",
              }}
            >
              -
            </div>
          )}
        </Box>
      )}
    </Box>
  );
};

export default GymBookingPage;
